const config = {
    basename: '/',
    defaultPath: '/invoice',
    fontFamily: `CoreSansG Light`,
    borderRadius: 12
};

export default config;
